import course from '@/api/course';

import {
    FETCH_PROGRAMS,
    POST_COURSE,
    PATCH_COURSE,
    PATCH_CURRENT_COURSE,
    DELETE_CURRENT_COURSE,
    DELETE_REMAINING_COURSES,
    DELETE_COURSE,
    NOTIFY_COURSE,
    CLOSE_COURSE,
    FETCH_COURSE,
    FETCH_STATS,
    FETCH_MULTI_STATS,
    COURSE_DRAFT_INITIALIZE,
    COURSE_USED_TRAINERS_FILL,
} from './types';

export default {
    [FETCH_PROGRAMS]({ commit }) {
        return course
            .programs()
            .then((resp) => {
                commit(FETCH_PROGRAMS, resp);
            });
    },
    [FETCH_COURSE]({ commit }, payload) {
        return course
            .get(payload.id)
            .then(resp => commit(FETCH_COURSE, resp));
    },
    [POST_COURSE]({ state, commit }) {
        return course
            .post(state.draft)
            .then((resp) => {
                commit(POST_COURSE, resp);
                // 记录使用过的会员
                if (state.draft.trainer_id) {
                    commit(COURSE_USED_TRAINERS_FILL, {
                        id: state.draft.trainer_id,
                    });
                }
                commit(COURSE_DRAFT_INITIALIZE);
            });
    },
    [PATCH_COURSE]({ state, commit }) {
        return course
            .patch(state.draft.id, state.draft)
            .then(resp => commit(PATCH_COURSE, resp));
    },
    [PATCH_CURRENT_COURSE]({ state, commit }) {
        return course
            .patchCurrent(state.draft.id, state.draft)
            .then(resp => commit(PATCH_CURRENT_COURSE, resp));
    },
    [DELETE_CURRENT_COURSE]({ commit }, payload) {
        return course
            .deleteCurrent(payload.id)
            .then(resp => commit(DELETE_CURRENT_COURSE, resp));
    },
    [DELETE_REMAINING_COURSES]({ commit }, payload) {
        return course
            .deleteRemaining(payload.id)
            .then(resp => commit(DELETE_REMAINING_COURSES, resp));
    },
    [DELETE_COURSE]({ commit }, payload) {
        return course
            .delete(payload.id)
            .then(resp => commit(DELETE_COURSE, resp));
    },
    [NOTIFY_COURSE]({ commit }, payload) {
        return course
            .notify(payload.id)
            .then(resp => commit(NOTIFY_COURSE, resp));
    },
    [CLOSE_COURSE]({ commit }, payload) {
        return course
            .close(payload.id)
            .then(resp => commit(CLOSE_COURSE, resp));
    },
    [FETCH_STATS]({ commit }, payload) {
        return course
            .stats(payload.date)
            .then(resp => commit(FETCH_STATS, {
                date: payload.date,
                stats: resp,
            }));
    },
    [FETCH_MULTI_STATS]({ commit }, payload) {
        return course
            .multiStats(payload.dates)
            .then(resp => commit(FETCH_MULTI_STATS, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/course/actions.js